export default {
  api: {
    baseUrl: 'https://api-roatex.mari.chat',
    chatUrl: 'https://api-roatex.channel.mari.chat',
  },
};
